// extracted by mini-css-extract-plugin
module.exports = {"button":"_3P7MG","hiddenLabel":"_1Nf_T"};